module.exports = __webpack_public_path__ + "static/media/homepage-classrooms.e6089449.svg";